<script setup lang="ts">
defineProps({
  offsetSplit: {
    type: Boolean,
    default: false,
  },

  reverseSplit: {
    type: Boolean,
    default: false,
  },

  thickBoi: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div :class="['widget-layout-row', $style.container, thickBoi && $style.thickBoi, offsetSplit && $style.offsetSplit, reverseSplit && $style.reverseSplit]">
    <div :class="[$style.widgetStart, offsetSplit && $style.offsetSplit, reverseSplit && $style.reverseSplit]">
      <slot name="widgetStart" />
    </div>

    <div :class="[$style.widgetEnd]">
      <slot name="widgetEnd" />
    </div>
  </div>
</template>

<style module>
.container {
  display: grid;
  width: 100%;
  margin-bottom: 1px;
  gap: 1px;
  grid-template-columns: 1fr 1fr;
}

.container.offsetSplit {
  grid-template-columns: 1fr 2fr;
}

.container.offsetSplit.reverseSplit {
  grid-template-columns: 2fr 1fr;
}

.container.thickBoi {
  margin-bottom: 0.25rem;
}

.container:last-child {
  margin-bottom: 0;
}

.widgetStart,
.widgetEnd {
  width: 100%;
  display: flex;
  flex-direction: column;
  /**Note Sven: Necessary in grid to restrict content to grid container lines */
  min-width: 0;
  min-height: 0;
}
</style>
